import { API_BASE_URL } from '@synergy/config';
import { InquiryOfferState } from '@synergy/models';
import { request } from '@synergy/api';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * How many inquiries wait for the supplier's offer, for the badge on "Offen"
 * in the rail (R-257).
 *
 * Asked again on every page change: answering an inquiry happens on its own
 * page, and the badge should be right once the supplier comes back to the list.
 */
export const useOpenInquiryCount = (): number | undefined => {
    const { pathname } = useLocation();
    const [count, setCount] = useState<number>();

    useEffect(() => {
        const controller = new AbortController();

        request
            .get(`${API_BASE_URL}/inquiries`, {
                params: { 'filter[inquiryOfferStates]': InquiryOfferState.Open, limit: 1, page: 1 },
                signal: controller.signal,
            })
            .then(response => setCount(response.data?.total))
            // An account the endpoint refuses simply shows no badge.
            .catch(() => undefined);

        return () => controller.abort();
    }, [pathname]);

    return count;
};
